export default __webpack_public_path__ + "static/media/result-popup.2f991a02.png";